import { ARROW_CENTER_FROM_EDGE_PX, ARROW_CENTER_FROM_SIDE_EDGE_PX } from './consts';
import type { FloatingAlign, FloatingSide } from './FloatingPlacement';

type AlignOffsetParams = {
  side: FloatingSide;
  align: FloatingAlign;
  triggerSize: { width: number; height: number };
};

const getAlignOffset = ({ side, align, triggerSize }: AlignOffsetParams): number => {
  if (align === 'center') {
    return 0;
  }

  if (side === 'top' || side === 'bottom') {
    return triggerSize.width / 2 - ARROW_CENTER_FROM_EDGE_PX;
  }

  return triggerSize.height / 2 - ARROW_CENTER_FROM_SIDE_EDGE_PX;
};

export default getAlignOffset;
